// extracted by mini-css-extract-plugin
export default {"heading":"RentalTermsPage_heading__FJGMX","content":"RentalTermsPage_content__PqomM"};